<template>
  <div id="academic_wbb">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro">
    </usc-intro>
    <div class="body gutter-lg mb">
      <p><i>Marshall’s 32 free electives can be used throughout the university, including toward a minor or a double major. These are in addition to 12 upper-level business units that can be taken across all business departments to allow you to delve into a specific area of interest such as entrepreneurship or consulting. This is equivalent to eight courses — a full year of free electives — that can be spread over four years of study. We also offer meaningful certificate programs that demonstrate your skills in a particular area.</i></p>
      <p>At Marshall, you call the shots. But you don’t have to go it alone. You’ll be supported by dedicated academic advisors, faculty and alumni mentors along the journey.</p>
      <img src="../../../static/explore-your-interests-24.png" title="32 Free Electives, 12 Upper-Level Business Electives, and 250+ business electives to choose from" alt="32 Free Electives and 12 Upper-Level Business Electives" style="width:100%;"/>
    </div>
    <div class="body gutter-lg mb">
      <h3>Sample Marshall Electives</h3>
      <h4>BAEP 460: Seminar in Entrepreneurship: The Entrepreneur’s Digital Toolkit</h4>
      <p>This course equips you with the necessary technology skills to build a startup in the digital space. You’ll be exposed to cloud technology, mobile architecture, social media, digital marketing and presentation skills for pitching investors. At the end, product videos are created and pitches are ready for submission to Kickstarter.</p>

      <h4>FBE 453a/b: Advanced Practicum in Investment Management</h4>
      <p>Sixteen Marshall undergraduate students gain hands-on experience in managing a portion of the university’s equity endowment. The course is designed to give you rigorous exposure to contemporary investment and portfolio theory and practice as well as an understanding of the money management business.</p>

      <h4>MOR 462: Management Consulting</h4>
      <p>In this course, you have the opportunity to go behind the scenes of the management consulting profession and some of its top firms. Consulting skills are fostered through written case analysis and discussion. Teams are assigned real-time consulting projects, which provide a unique learning experience in the business world.</p>

      <h4>MKT 446: Practicum in New Product Development and Branding</h4>
      <p>In this experiential learning course, students step into the shoes of a product manager and lead the development of an actual product. You will research, create, design and develop prototypes and marketing plans for a successful new product introduction for a brand. The course is collaboratively taught by faculty from Marshall and the Viterbi School of Engineering and Roski School of Fine Arts.</p>

      <h4>MOR 558: Technology Strategy in the Age of AI</h4>
      <p>Artificial intelligence is becoming ubiquitous across all industries. As a result, it is likely that, regardless of your chosen path, you will encounter situations where decisions about involvement with AI technologies need to be made. Technology strategy provides the tools necessary to make such decisions. Rather than looking at the role of past technological changes in shaping societal and business outcomes, this class takes a forward-looking approach and focuses on emerging technologies and their likely role in shaping the technology strategy of modern businesses.</p>

    </div>
     <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed>
  </div>
</template>

<script>
import hero from '@/components/Hero'
import intro from '@/components/Intro'
import CourseChart from '@/components/CourseChart/CourseChart'
import Cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'

export default {
  name: 'Electives',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-course-chart': CourseChart,
    'usc-cta': Cta,
    'usc-videoEmbed': videoEmbed
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Electives',
        loResSrc: '../../../static/HeroImages/Marshall116-High.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall116-High.jpg'
      },
      intro: [
        'Marshall students may take half of all undergraduate units outside of the school. This provides you access to the many benefits of being at a world-class university — such as exposure to innovative research, internationally acclaimed faculty and cutting-edge programs across a wide range of fields. You’ll learn beside budding filmmakers, engineers, regulatory scientists, urban planners, journalists and other future leaders.'
      ],
      video: {
        caption: 'The Marshall Difference: Human-Centric Problem-Solving - AJ Ogilvie, Assistant Professor of Clinical Business Communication',
        src: 'https://player.vimeo.com/video/642795234',
        frameTitle: 'The Marshall Difference: Human-Centric Problem-Solving - AJ Ogilvie, Assistant Professor of Clinical Business Communication'
      }
    }
  },
  created () {
    this.$root.setPageHeader('Academics', 'Electives')
  }
}
</script>

<style scoped lang="scss">
  .wbb-logos {
    width: 100%;
    max-width: 870px;
    margin: 0 auto;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/pages/academics/Electives.vue